query SearchProducts(
    $discovery: Boolean!
    $filter: ProductSearchInput!
    $language: String
    $page: CursorPageSelectionInput
) {
    searchProducts(
        filter: $filter
    ) {
        results(
            page: $page
        ) {
            nodes @skip(if: $discovery) {
                id
                revisionID

                bimClass
                brand
                name(language: $language) {
                    language
                    text
                }
                naturalKey
                countries
            }
            totalCount
            pageInfo {
                endCursor
                hasNext
            }
        }

        enumerateBimClasses {
            bimClass
            count
        }
        enumerateBrands {
            brand
            count
        }
        enumerateCountries {
            country
            count
        }
    }
}
